// Quiet hierarchy context (Client › Brand › Campaign) for detail screens.
import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { Fragment } from "react";
import { useFrontDesk } from "@/api/hooks";
import { useBrand, useCampaign, useClient } from "./queries";

export function Breadcrumbs({
  orgId,
  clientId,
  brandId,
  campaignId,
  current,
}: {
  orgId: string;
  clientId?: string | undefined;
  brandId?: string | undefined;
  campaignId?: string | undefined;
  current: string;
}) {
  // Simple workspaces (one client → brand chain) never see Client/Brand: just the work.
  const { data: fd } = useFrontDesk(orgId);
  const simple = Boolean(fd?.creationContext);
  const client = useClient(orgId, simple ? undefined : clientId);
  const brand = useBrand(orgId, simple ? undefined : brandId);
  const campaign = useCampaign(orgId, campaignId);
  const base = `/o/${orgId}`;
  const crumbs: Array<{ label: string; to: string }> = simple
    ? [{ label: "Creatividades", to: `${base}/creatives` }]
    : [];
  if (clientId && client.data) crumbs.push({ label: client.data.name, to: `${base}/clients/${clientId}` });
  if (brandId && brand.data) crumbs.push({ label: brand.data.name, to: `${base}/brands/${brandId}` });
  if (campaignId && campaign.data) crumbs.push({ label: campaign.data.name, to: `${base}/campaigns/${campaignId}` });
  return (
    <nav aria-label="Ubicación" className="flex flex-wrap items-center gap-1 text-xs text-muted">
      {crumbs.map((crumb) => (
        <Fragment key={crumb.to}>
          <Link to={crumb.to} className="hover:text-fg hover:underline">
            {crumb.label}
          </Link>
          <ChevronRight className="size-3" aria-hidden="true" />
        </Fragment>
      ))}
      <span aria-current="page" className="text-fg">
        {current}
      </span>
    </nav>
  );
}
